import clsx from "clsx";
import { IAdminUnit } from "../adminTypes";
import { useQuery } from "@tanstack/react-query";
import { adminGetUnitMls } from "../queries";
import { ContentContext } from "../../../contexts/contextExporter";
import { useContext } from "react";
import ItemMl from "./ItemMl";

export default function ItemUnit({ unit }: { unit: IAdminUnit }) {
  const { pickedTree, setPickedTree } = useContext(ContentContext);

  const isPicked = pickedTree.unitId === unit.id;
  const { data: unitMls } = useQuery(
    adminGetUnitMls({ unitId: unit.id, enabled: isPicked })
  );

  return (
    <div className={clsx(isPicked ? "py-3" : "")}>
      <div
        onClick={() =>
          isPicked
            ? null
            : setPickedTree({ unitId: unit.id, mlId: null, partId: null })
        }
        className={clsx(
          "py-2 transition-all text-base",
          isPicked
            ? "px-2.5 bg-myGreen/50 rounded-t-xl"
            : "cursor-pointer pr-5 hover:pl-2.5 hover:pr-2.5 text-white/80 hover:text-white/100 hover:bg-white/10 rounded-xl"
        )}
      >
        {unit.name}{" "}
        <span className="text-white/50">
          (prevSp: {unit.prev_sprint_order || "-"}, id: {unit.id})
        </span>
      </div>
      {/*  */}
      {unitMls && isPicked && (
        <div className="text-sm p-1 border border-myGreen/50 rounded-b-xl">
          {unitMls.map((ml) => (
            <ItemMl ml={ml} key={ml.id} />
          ))}
        </div>
      )}
    </div>
  );
}
